import BasicInfoSection from './BasicInfoSection'

export default BasicInfoSection
